import 'core-js/features/promise/all-settled';
import "array-flat-polyfill";
import "mdn-polyfills/String.prototype.endsWith";
import "normalize.css/normalize.css";
import { createApp } from "vue";
import { mainRouter } from "./router";
import App from "./App.vue";
import { create, NTooltip } from "naive-ui";
import "@/assets/css/page.less";
import { track } from "@/libs/track";
import * as Sentry from "@sentry/vue";

const naive = create({
  components: [NTooltip],
});

track.init();
declare global {
  interface Window {
    _hot: any;
    [key: string]: any;
  }
}
/* 实例化根组件 */
const app = createApp(App);
if (import.meta.env.MODE === "prd") {
  // 初始化sentry
  Sentry.init({
    app,
    dsn: SY_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router: mainRouter })
    ],
    tracesSampleRate: 0,
    trackComponents: true,
  });
}
app.use(mainRouter).use(naive).mount("#app");
